import React from "react";

import { Box, Flex, ParagraphMd } from "@olist/design-system";

import { CustomBadge, CustomLink } from "./styles";

function getShortenedDescription(
  description: string,
  maxLength: number
): string {
  if (description.length <= maxLength) return description;

  const trimmedString = description.substr(0, maxLength);
  const lastSpaceIndex = trimmedString.lastIndexOf(" ");

  if (lastSpaceIndex === -1) return trimmedString;

  return `${trimmedString.substr(0, lastSpaceIndex)}...`;
}

function getProductTag(path: string): string | null {
  const validProductsTags = {
    erp: "ERP",
    "conta-digital": "Conta Digital",
    loja: "Loja",
    envios: "Envios",
    "agentes-de-ia": "Agentes de IA",
  };

  const pathParts = path.split("/");
  try {
    const productTag = validProductsTags[pathParts[3]];
    return productTag ?? null;
  } catch (error) {
    return null;
  }
}

interface IArticleItemProps {
  title: string;
  description: string;
  path: string;
}

export function ArticleItem({ description, path, title }: IArticleItemProps) {
  const shortenedDescription = getShortenedDescription(description, 100);
  const productTag = getProductTag(path);

  return (
    <Flex flexDirection="column" my="12px">
      <Box>
        <CustomLink to={path}>{title}</CustomLink>
        {productTag && (
          <CustomBadge key={productTag} variation="primary">
            {productTag}
          </CustomBadge>
        )}
      </Box>
      <ParagraphMd>{shortenedDescription}</ParagraphMd>
    </Flex>
  );
}
